import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import {
  EPlatform,
  ERequestState,
  MembershipRequestApi,
  MembershipRequestDto,
  RequestDto,
  TempRSHRequestDto,
} from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { DrupalMembershipForm } from "./DrupalMembershipForm";

export interface IDrupalMembershipRequestProps {}

export const DrupalMembershipRequest: React.FunctionComponent<IDrupalMembershipRequestProps> = () => {
  const { id } = useParams<{ id: string }>();
  const membershipRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(MembershipRequestApi);

  const { data, loading, saving } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: (apiId = membershipRequestId) =>
          apiId > 0
            ? api.get(apiId)
            : new MembershipRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: TempRSHRequestDto) =>
          api.save(MembershipRequestDto.fromJS({ ...d, isPortal: true })),
        deleteApiFn: () => {},
      }),
      [api, membershipRequestId]
    ),
    []
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet
        title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.MembershipRequest)}`}
      >
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalMembershipForm
                  membershipRequestId={membershipRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
